module.exports = __webpack_public_path__ + "static/media/loadhub-cash.f29ab771.jpg";